import { useContext, useEffect } from "react";
import { AppContext } from "@CONTEXTS";
import { Select } from "antd";

const { Option } = Select;

const OptionSelect = (props, { value = null, onChange, placeholder }) => {
  const { options } = useContext(AppContext);
  const { labelKey = "tr", ...selectProps } = props;
  if (!options[props.name]) return "Hata!";

  return (
    <Select
      style={{ width: "100%" }}
      placeholder={placeholder}
      allowClear={props.allowClear || true}
      onChange={onChange}
      value={value}
      {...selectProps}
    >
      {options[props.name].map((item, index) => (
        <Option key={index} value={item.key}>
          {item[labelKey] ?? item.tr}
        </Option>
      ))}
    </Select>
  );
};

export default OptionSelect;
